import { Injectable } from '@angular/core';
import { LoggingService } from '../logging-service/logging.service';
import { BROWSERS, DeviceDetectorService, OS } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class AppDeepLinkService {
  private readonly hashParamAuthId = 'authRefId';
  private readonly resumeStateToken = 'resumeStateToken';

  constructor(
    private loggingService: LoggingService,
    private deviceService: DeviceDetectorService
  ) {}

  public startBankId(
    autoStartToken?: string,
    authRefId?: string
  ): Promise<void> {
    let fullUrl: string;

    if (autoStartToken) {
      fullUrl = 'bankid:///?autostarttoken=' + autoStartToken + '&redirect=';
    } else {
      fullUrl = 'bankid:///?redirect=';
    }

    return this.startBankIdFullUrl(fullUrl, authRefId);
  }

  public startBankIdFullUrl(url: string, authRefId?: string): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => {
        let redirect: string;

        const deviceInfo = this.deviceService.getDeviceInfo();

        if (deviceInfo.os === OS.IOS) {
          if (deviceInfo.browser === BROWSERS.CHROME) {
            redirect = 'googlechrome://';
          } else if (deviceInfo.browser === BROWSERS.FIREFOX) {
            redirect = 'firefox://';
          } else {
            // Apparently Safari shouldn't reload the page if the redirect url is the same and contains
            // any hash parameters. This behaviour is not documented anywhere!
            // If users uses different browser they will be redirected to Safari by default
            // Since the Browser is new the session will be lost. Use a resume token logic to avoid no-state errors.
            redirect = `${window.location.href}#${this.hashParamAuthId}=${authRefId}`;
          }
        } else if (deviceInfo.userAgent.includes('HeyTapBrowser')) {
          // OPPO, realme and OnePlus devices have HeyTapBrowser pre-installed although it is
          // chromium-based it works similar to the above IOS exception and thus requires a
          // redirect to the user's default browser.
          redirect = `${window.location.href}#${this.hashParamAuthId}=${authRefId}`;
        } else {
          redirect = 'null';
        }

        const deepLink = url + encodeURIComponent(redirect);

        this.loggingService.warn(
          'Attempting to launch with deep link: ' + deepLink
        );
        window.location.replace(deepLink);
        resolve();
      }, 200);
    });
  }

  getCurrentAuthRefId(): string {
    const hashParamsString = window.location.hash.substring(1);
    const params = new URLSearchParams(hashParamsString);

    return params.get(this.hashParamAuthId);
  }

  public startSwish(autoStartToken: string): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const redirectTarget: string =
          window.location.href + '&poppedSwish=true';
        let deepLink: string = 'swish://paymentrequest?token=' + autoStartToken;

        const deviceInfo = this.deviceService.getDeviceInfo();
        if (deviceInfo.os === OS.IOS) {
          if (deviceInfo.browser === BROWSERS.CHROME) {
            deepLink += '&callbackurl=googlechrome://';
          } else if (deviceInfo.browser === BROWSERS.FIREFOX) {
            deepLink += '&callbackurl=firefox://';
          } else {
            deepLink += '&callbackurl=' + encodeURIComponent(redirectTarget);
          }
        }
        this.loggingService.warn('launching deep link: ' + deepLink);
        window.location.replace(deepLink);
        resolve();
      }, 200);
    });
  }
}
